/**
 * ログイン用パスキーの日本語（en.loginPasskey.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。
 * 表記の決め事は ja.ts の冒頭と同じ。出金用（pk.*・「パスキー」）と取り違えないよう、こちらは必ず「ログイン用パスキー」と書く。
 */
import type { enLoginPasskey } from './en.loginPasskey';

type LoginPasskeyMessages = { [K in keyof typeof enLoginPasskey]: string };

export const jaLoginPasskey: LoginPasskeyMessages = {
  'auth.passkeyUnavailable': '今はパスキーでログインできません。別の方法でログインしてください。',

  'reauth.passkey': 'パスキーで確認',
  'reauth.passkeyNote': 'ログイン用パスキー（Face ID・Touch ID・Windows Hello・セキュリティキー）で確認します。',
  'reauth.passkeyFailed': 'パスキーで確認できませんでした。もう一度お試しいただくか、別の方法で確認してください。',

  'lpk.title': 'ログイン用パスキー',
  'lpk.lead': 'パソコンやスマホの顔認証・指紋・画面ロックで、メールアドレスやパスワードを入れずにログインできます（Face ID・Touch ID・Windows Hello・セキュリティキー）。',
  'lpk.separate': '出金の確認に使うパスキーとは別です。ログイン用パスキーでは出金を確認できず、出金用のパスキーではログインできません。',
  'lpk.moneyLink': '出金用のパスキー（お金 → パスキー）',
  'lpk.empty': 'ログイン用パスキーはまだありません。',
  'lpk.add': 'ログイン用パスキーを追加',
  'lpk.addTitle': 'ログイン用パスキーを追加',
  'lpk.label': '名前',
  'lpk.labelPlaceholder': '例: MacBook、iPhone',
  'lpk.create': 'パスキーを作成',
  'lpk.addHint': '先にあなた本人かを確かめてから、端末の画面でパスキーを作ります。',
  'lpk.reauthResumed': 'あなた本人だと確かめられました。もう一度「パスキーを作成」を押してください。',
  'lpk.added': 'ログイン用パスキーを追加しました。次回からこのパスキーでログインできます。',
  'lpk.removed': 'ログイン用パスキーを削除しました。念のため、ほかの端末のダッシュボードと、つないでいたAIエージェントやターミナルのコマンドはログアウトしました（もう一度ログインすれば使えます）。',
  'lpk.remove': '削除',
  'lpk.removeTitle': '「{label}」を削除しますか？',
  'lpk.removeBody': 'このパスキーではログインできなくなります。端末に残ったパスキーは、端末の設定から削除してください。',
  'lpk.lastNote': 'ほかにログインの方法が無いため削除できません。先にパスワードを設定するか、別のログイン方法を追加してください。',
  'lpk.neverUsed': 'まだ使っていません',
  'lpk.cancelled': 'パスキーの画面が閉じられました。何も追加していません。',
  'lpk.alreadyOnDevice': 'この端末には、このアカウントのログイン用パスキーがすでにあります。',
  'lpk.unsupported': 'このブラウザではパスキーを使えません。最新の Chrome・Safari・Edge・Firefox をお試しください。',
  'lpk.unavailable': '今はログイン用パスキーを追加できません。メールアドレスとパスワードなど、別の方法でログインしてください。',
  'lpk.max': 'ログイン用パスキーは{max}本までです。追加するには先に1本削除してください。',
  'lpk.lost': '端末を失くしたときは、別の方法でログインするか、ログイン画面の「パスワードを忘れた」から設定し直してください。'
};
